import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=79cc78b4&scoped=true"
import script from "./LayoutAuth.vue?vue&type=script&lang=js"
export * from "./LayoutAuth.vue?vue&type=script&lang=js"
import style0 from "@/vendor/styles/pages/authentication.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./LayoutAuth.vue?vue&type=style&index=1&id=79cc78b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc78b4",
  null
  
)

export default component.exports